import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 2.5rem 1.5rem 0;
`;

export const Title = styled.div`
  font-size: 28px;
  font-weight: 700;
  white-space: pre-wrap;
  line-height: 34px;
`;

export const Strong = styled.span`
  color: ${({ theme }) => theme.palette.brand300};
  line-height: 34px;
`;

export const SubTitle = styled.div`
  margin-top: 2.5rem;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.palette.gray100};
`;
